/*
  TAFKA Custom Asset: Shipping Progress Bar
  Extracted from snippets/shipping-progress-bar-portable.liquid so the script
  is loaded globally via layout/theme.liquid (defer) and runs on every page.

  Why global: the Eurus cart drawer is (re-)rendered via the Section Rendering API
  and injected with innerHTML - inline <script> tags inside that HTML never execute.
  The bar instance in the drawer therefore can only be initialised by a script
  that is already running on the page.

  Cart sync: Eurus core (assets/theme.js) and every cart add-on dispatch the
  document event "eurus:cart:items-changed" on every cart mutation (add / quantity
  change / remove), including the drawer +/- buttons. We subscribe to it so that a
  bar rendered OUTSIDE the drawer (e.g. on the product page) recomputes when the
  cart changes from anywhere - not just on page reload. Generic events are kept as
  fallbacks so the component stays portable to other themes.

  Author: Lukas Follert
  Created: 2026-06-05
  Updated: 2026-07-01 - subscribe to eurus:cart:items-changed; refresh all bars
                        from one /cart.js fetch; register triggers once (no leak).
  Updated: 2026-09-28 - Gewichtsfreigabe (data-spb-free-weight): ab diesem Warenkorb-
                        gewicht ist alles freigeschaltet (Weinpaket), eigene Meldung.
*/
(function () {
  function readConfig(container) {
    return {
      target: parseFloat(container.dataset.spbTarget) || 6,
      trackBy: container.dataset.spbTrackBy || 'weight',
      unit: container.dataset.spbUnit || '',
      msgProgress: container.dataset.spbMsgProgress || 'Add [remaining] more for free shipping!',
      msgComplete: container.dataset.spbMsgComplete || 'Free shipping unlocked!',
      msgAllComplete: container.dataset.spbMsgAllComplete || container.dataset.spbMsgComplete || '',
      max: parseFloat(container.dataset.spbMax) || parseFloat(container.dataset.spbTarget) || 6,
      tiers: parseTiers(container.dataset.spbTiers),
      // Gewichtsfreigabe (z. B. Weinpaket mit 180 kg): erreicht der Warenkorb dieses Gewicht,
      // ist unabhaengig vom Wert alles freigeschaltet. 0/leer = aus.
      freeWeight: parseFloat(container.dataset.spbFreeWeight) || 0,
      msgFreeWeight: container.dataset.spbMsgFreeWeight || ''
    };
  }

  // data-spb-tiers is a JSON array [{t: <threshold>, label: "..."}]. A malformed value must not
  // take the whole bar down — fall back to single-tier behaviour.
  function parseTiers(raw) {
    if (!raw) return [];
    try {
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return [];
      return list
        .filter(function (x) { return x && typeof x.t === 'number' && x.t > 0; })
        .sort(function (a, b) { return a.t - b.t; });
    } catch (e) {
      return [];
    }
  }

  // Paint a single bar from an already-fetched cart object.
  function renderBar(container, cart) {
    var config = readConfig(container);
    var messageEl = container.querySelector('[data-spb-message]');
    var fillEl = container.querySelector('[data-spb-fill]');
    var indicatorEl = container.querySelector('[data-spb-indicator]');
    if (!fillEl || !messageEl) return;

    var current = 0;
    if (config.trackBy === 'weight') {
      current = cart.total_weight / 1000; // grams to kg
    } else if (config.trackBy === 'price') {
      current = cart.total_price / 100; // cents to currency
    } else if (config.trackBy === 'quantity') {
      current = cart.item_count;
    }

    // Multi-tier fills against the HIGHEST threshold; single-tier keeps filling against target,
    // so an existing single-tier bar behaves exactly as before.
    var multi = config.tiers.length > 1;
    var scale = multi ? config.max : config.target;

    // Gewichtsfreigabe schlaegt Wert und Stufen: ab diesem Gewicht verschickt der Shop gratis
    // (Ott: Weinpakete tragen 180 kg). Dann Balken voll, alle Stufen erreicht, eigene Meldung.
    var freeByWeight = config.freeWeight > 0 && (cart.total_weight / 1000) >= config.freeWeight;

    // The next tier the customer has not reached yet. Null once everything is unlocked.
    var nextTier = null;
    if (!freeByWeight) {
      for (var i = 0; i < config.tiers.length; i++) {
        if (current < config.tiers[i].t) { nextTier = config.tiers[i]; break; }
      }
    }

    var progress = freeByWeight ? 100 : Math.min((current / scale) * 100, 100);
    var goal = multi ? (nextTier ? nextTier.t : config.max) : config.target;
    var remaining = Math.max(goal - current, 0);
    // Preis-Modus braucht das Landesformat: toFixed(1) lieferte "63.1" — mit PUNKT und
    // einer Nachkommastelle, fuer Euro-Betraege auf einem deutschen Shop beides falsch.
    // Mengen (Flaschen/Kilo) bleiben ganzzahlig wie bisher.
    var remainingStr;
    if (config.trackBy === 'price') {
      remainingStr = remaining.toLocaleString(document.documentElement.lang || undefined,
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
      remainingStr = remaining % 1 === 0 ? remaining.toString() : remaining.toFixed(1);
    }
    var isComplete = freeByWeight || (multi ? nextTier === null : current >= config.target);
    var hasItems = current > 0;

    paintTiers(container, config, freeByWeight ? Infinity : current, scale);

    // Fill bar
    fillEl.style.width = progress + '%';
    fillEl.classList.toggle('spb-complete', isComplete);

    // Indicator (optional)
    if (indicatorEl) {
      indicatorEl.style.left = progress + '%';
      indicatorEl.classList.remove('spb-active', 'spb-complete');
      if (isComplete) {
        indicatorEl.classList.add('spb-complete');
      } else if (hasItems) {
        indicatorEl.classList.add('spb-active');
      }
    }

    // Message
    if (freeByWeight && config.msgFreeWeight) {
      messageEl.textContent = config.msgFreeWeight;
    } else if (isComplete) {
      messageEl.textContent = multi ? config.msgAllComplete : config.msgComplete;
    } else if (multi && nextTier) {
      var withUnit = config.unit ? remainingStr + ' ' + config.unit : remainingStr;
      messageEl.textContent = config.msgProgress
        .replace('[remaining]', withUnit)
        .replace('[reward]', nextTier.label || '');
    } else {
      var remainingWithUnit = config.unit ? remainingStr + ' ' + config.unit : remainingStr;
      messageEl.textContent = config.msgProgress.replace('[remaining]', remainingWithUnit);
    }
  }

  // Milestone dots + legend ticks. Positions come from the same tier list the legend renders from,
  // so markup and maths cannot drift apart.
  function paintTiers(container, config, current, scale) {
    var dots = container.querySelector('[data-spb-milestones]');
    if (dots && config.tiers.length > 1) {
      if (dots.children.length !== config.tiers.length) {
        dots.textContent = '';
        config.tiers.forEach(function () {
          var d = document.createElement('span');
          d.className = 'spb-portable__milestone';
          dots.appendChild(d);
        });
      }
      config.tiers.forEach(function (tier, i) {
        var dot = dots.children[i];
        dot.style.left = Math.min((tier.t / scale) * 100, 100) + '%';
        dot.classList.toggle('spb-reached', current >= tier.t);
      });
    }

    var legend = container.querySelector('[data-spb-legend]');
    if (legend) {
      legend.querySelectorAll('[data-spb-legend-item]').forEach(function (li) {
        var threshold = parseFloat(li.dataset.spbLegendItem);
        li.classList.toggle('spb-reached', !isNaN(threshold) && current >= threshold);
      });
    }
  }

  // Update every bar currently in the DOM from ONE cart fetch. Debounced so a
  // burst of cart events collapses into a single request.
  var refreshScheduled = false;
  function refreshAllBars() {
    if (refreshScheduled) return;
    refreshScheduled = true;
    setTimeout(function () {
      refreshScheduled = false;
      var bars = document.querySelectorAll('[data-spb-container]');
      if (!bars.length) return;
      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          bars.forEach(function (bar) { renderBar(bar, cart); });
        })
        .catch(function (error) {
          console.error('Shipping progress bar: Failed to fetch cart', error);
        });
    }, 50);
  }

  // Cart-change triggers - registered ONCE per page (not per bar, so re-rendered
  // drawer bars don't pile up duplicate listeners).
  function bindGlobalTriggers() {
    if (window.__spbTriggersBound) return;
    window.__spbTriggersBound = true;

    // Eurus core + add-ons dispatch this on every cart mutation. This is the fix.
    document.addEventListener('eurus:cart:items-changed', refreshAllBars);

    // Generic fallbacks for portability to non-Eurus themes.
    ['cart:updated', 'cart:change', 'ajaxCart:updated', 'cart:item-added', 'theme:cart:change']
      .forEach(function (evt) { document.addEventListener(evt, refreshAllBars); });

    // Last-resort fallback: any add-to-cart click (themes with no cart event).
    document.body.addEventListener('click', function (e) {
      var addToCartSelectors = [
        '[data-add-to-cart]',
        'form[action*="/cart/add"]',
        '.product-form__submit',
        '.add-to-cart',
        '[name="add"]',
        '.btn-add-to-cart'
      ];
      for (var i = 0; i < addToCartSelectors.length; i++) {
        if (e.target.closest(addToCartSelectors[i])) {
          setTimeout(refreshAllBars, 500);
          setTimeout(refreshAllBars, 1000);
          break;
        }
      }
    });
  }

  // First paint for a bar (covers freshly AJAX-injected drawer bars).
  function initShippingBar(container) {
    if (container.__spbInited) return;
    container.__spbInited = true;
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) { renderBar(container, cart); })
      .catch(function (error) {
        console.error('Shipping progress bar: Failed to fetch cart', error);
      });
  }

  function init() {
    bindGlobalTriggers();
    document.querySelectorAll('[data-spb-container]').forEach(initShippingBar);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan whenever new containers appear (e.g. cart drawer injected via AJAX).
  // Guard so the observer is only set up once per page even if the script loads twice.
  if (!window.__spbObserverActive) {
    window.__spbObserverActive = true;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) { init(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }


  // Testbarkeit: im Browser inert (kein `module`), unter Node exportiert es die reine Rechenlogik,
  // damit die Stufen-Mathematik ohne echtes DOM geprüft werden kann. Siehe tests/shipping-bar.test.js.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { parseTiers: parseTiers, renderBar: renderBar };
  }
})();
